module.exports = __webpack_public_path__ + "assets/img/sai_imow_hero.41f53763.jpg";